"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CordViewsViewName = void 0;
var CordViewsViewName = /*#__PURE__*/function (CordViewsViewName) {
  CordViewsViewName["DossierStatusCount"] = "DossierStatusCount";
  CordViewsViewName["DossierStatusOverview"] = "DossierStatusOverview";
  CordViewsViewName["TeamOverview"] = "TeamOverview";
  CordViewsViewName["ManagementInformation"] = "ManagementInformation";
  CordViewsViewName["DossierOverview"] = "DossierOverview";
  CordViewsViewName["TaskOverview"] = "TaskOverview";
  CordViewsViewName["AuthorizationManagement"] = "AuthorizationManagement";
  CordViewsViewName["TeamDetails"] = "TeamDetailsView";
  return CordViewsViewName;
}(CordViewsViewName || (exports.CordViewsViewName = CordViewsViewName = {}));

